import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, onDesktop} from "@pg-design/helpers-css";

import {usePropertyPlannerEstateDetails} from "../../hooks/use_property_planner_estate_details";
import {PropertyLocationBetweenOtherProperties} from "./PropertyLocationBetweenOtherProperties";
import {PropertyLocationDaylight} from "./PropertyLocationDaylight";
import {PropertyLocationExposure} from "./PropertyLocationExposure";

interface IProps {
    className?: string;
}

export const PropertyLocationAttributes = (props: IProps) => {
    const {totalStats, plannerEstateDetails} = usePropertyPlannerEstateDetails();
    const hasIsMiddle = typeof plannerEstateDetails?.is_middle === "boolean";

    if (!plannerEstateDetails || (!totalStats?.daylightLevel && !plannerEstateDetails.rooms && !hasIsMiddle)) {
        return null;
    }

    return (
        <div css={wrapperStyle} className={props.className}>
            {totalStats?.daylightLevel && <PropertyLocationDaylight sunshineLevel={totalStats.daylightLevel} />}
            {plannerEstateDetails.rooms && <PropertyLocationExposure propertyRooms={plannerEstateDetails.rooms} />}
            {hasIsMiddle && <PropertyLocationBetweenOtherProperties isMiddle={plannerEstateDetails.is_middle} />}
        </div>
    );
};

const wrapperStyle = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(1.5)};

    ${onDesktop(css`
        flex-direction: row;
        gap: ${calculateRemSize(2)};
    `)};
`;
import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, onDesktop} from "@pg-design/helpers-css";

import {usePropertyPlannerEstateDetails} from "../../hooks/use_property_planner_estate_details";
import {PropertyLocationBetweenOtherProperties} from "./PropertyLocationBetweenOtherProperties";
import {PropertyLocationDaylight} from "./PropertyLocationDaylight";
import {PropertyLocationExposure} from "./PropertyLocationExposure";

interface IProps {
    className?: string;
}

export const PropertyLocationAttributes = (props: IProps) => {
    const {totalStats, plannerEstateDetails} = usePropertyPlannerEstateDetails();
    const hasIsMiddle = typeof plannerEstateDetails?.is_middle === "boolean";

    if (!plannerEstateDetails || (!totalStats?.daylightLevel && !plannerEstateDetails.rooms && !hasIsMiddle)) {
        return null;
    }

    return (
        <div css={wrapperStyle} className={props.className}>
            {totalStats?.daylightLevel && <PropertyLocationDaylight sunshineLevel={totalStats.daylightLevel} />}
            {plannerEstateDetails.rooms && <PropertyLocationExposure propertyRooms={plannerEstateDetails.rooms} />}
            {hasIsMiddle && <PropertyLocationBetweenOtherProperties isMiddle={plannerEstateDetails.is_middle} />}
        </div>
    );
};

const wrapperStyle = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(1.5)};

    ${onDesktop(css`
        flex-direction: row;
        gap: ${calculateRemSize(2)};
    `)};
`;
